export default __webpack_public_path__ + "static/flag-at-72569734be70a437a562f2f018621bff.svg";